import { render, staticRenderFns } from "./card-faq-delete-account.vue?vue&type=template&id=614befe1&scoped=true&"
import script from "./card-faq-delete-account.vue?vue&type=script&lang=js&"
export * from "./card-faq-delete-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614befe1",
  null
  
)

export default component.exports